<template>
  <!-- ADD STAFF -->
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="addStaffModal"
      persistent
      max-width="900px"
    >
      <v-card>
        <form
          action=""
          @submit.prevent="submitForm()"
        >
          <v-card-title>
            <v-flex
              xs11
              sm11
              md11
            ><span class="headline">{{ $t('user.addStaffTitle') }}</span></v-flex>
            <v-flex
              xs1
              sm1
              md1
            >
              <v-btn
                flat
                @click="closeAddStaffModal(), $validator.reset()"
                class="close"
              ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-alert
              type="success"
              :value="checkAlert"
            >
              {{ $t('user.staffAddedSuccessfully') }}
            </v-alert>
            <v-alert
              type="error"
              :value="validationError"
            >
              <h4>{{ emailError }}</h4>
            </v-alert>
            <v-alert
              type="error"
              :value="phoneValidation"
            >
              <h4>{{ phoneError }}</h4>
            </v-alert>
            <v-alert
              :value="passwordAlert"
              type="error"
              style="height:50px"
            >
              <h4 style="padding-top:10px">{{ $t('user.passwordDoNotMatch') }}</h4>
            </v-alert>
            <v-layout wrap>
              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-text-field
                  :label="$t('user.fullName') + '*'"
                  v-model="addData.full_name"
                  :error-messages="errors.collect('full_name')"
                  v-validate="'required'"
                  data-vv-name="full_name"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-text-field
                  :label="$t('columns.email') + '*'"
                  v-model="addData.email"
                  :error-messages="errors.collect('email')"
                  v-validate="'required|email'"
                  data-vv-name="email"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-text-field
                  :label="$t('columns.phoneNumber') + '*'"
                  v-model="addData.phone_number"
                  :error-messages="phoneFieldErrors"
                  v-validate="'required'"
                  data-vv-name="phone_number"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-text-field
                  :append-icon="e2 ? 'visibility' : 'visibility_off'"
                  :append-icon-cb="() => (e2 = !e2)"
                  :type="e2 ? 'password' : 'text'"
                  :label="$t('login.password') + '*'"
                  v-model="addData.password"
                  :error-messages="errors.collect('password')"
                  v-validate="'required|min:6'"
                  data-vv-name="password"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-text-field
                  :append-icon="e1 ? 'visibility' : 'visibility_off'"
                  :append-icon-cb="() => (e1 = !e1)"
                  :type="e1 ? 'password' : 'text'"
                  :label="$t('user.confirmPassword') + '*'"
                  v-model="addData.confirm_password"
                  :error-messages="errors.collect('confirm_password')"
                  v-validate="'required|min:6'"
                  data-vv-name="confirm_password"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-select
                  :items="roles"
                  item-value="value"
                  v-model="addData.rolesId"
                  :error-messages="errors.collect('roles')"
                  data-vv-name="roles"
                  :label="$t('columns.role') + '*'"
                  v-validate="'required'"
                  multiple
                  chips
                  deletable-chips
                  autocomplete
                >
                </v-select>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-select
                  :items="warehouses"
                  item-value="value"
                  v-model="addData.warehouse_id_fk"
                  :error-messages="errors.collect('Warehouse')"
                  data-vv-name="Warehouse"
                  :label="$t('columns.warehouse') + '*'"
                  v-validate="'required'"
                  multiple
                  chips
                  deletable-chips
                >
                </v-select>
              </v-flex>

              <!-- <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-select
                  :items="branches"
                  item-value="value"
                  v-model="addData.default_branch_id_fk"
                  :error-messages="errors.collect('Default Branch')"
                  data-vv-name="Default Branch"
                  label="Default Branch*"
                  v-validate="'required'"
                >
                </v-select>
              </v-flex> -->

              <!-- <v-flex
                xs12
                class="px-2"
              >
                <v-select
                  :items="branches"
                  item-value="value"
                  v-model="addData.branchesId"
                  :error-messages="errors.collect('Branch')"
                  data-vv-name="Branch"
                  label="Branch*"
                  v-validate="'required'"
                  multiple
                  chips
                  deletable-chips
                >
                </v-select>
              </v-flex> -->
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeAddStaffModal(), $validator.reset()"
              outline
              color="normal"
            >{{ $t('common.cancel') }}</v-btn>
            <v-btn
              type="submit"
              style="height:auto" class="rtl-mr-3pct"
              outline
              color="success"
            >{{ $t('common.add') }}</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
  <!-- /ADD STAFF -->
</template>

<script>
export default {
  props: [
    'addStaff',
    'roles',
    'warehouses',
    'branches',
    'addData',
    'addStaffModal',
    'checkAlert',
    'closeAddStaffModal',
    'emailError',
    'validationError',
    'phoneValidation',
    'phoneError'
  ],

  data() {
    return {
      passwordAlert: false,
      e1: true,
      e2: true
    }
  },

  computed: {
    phoneFieldErrors() {
      let veeErrors = this.errors.collect('phone_number')
      if (veeErrors && veeErrors.length > 0) return veeErrors
      let phone = this.addData.phone_number
      if (phone && phone.trim() !== '' && !phone.trim().startsWith('+964')) {
        return [this.$t('user.phoneMustStartWith964Error')]
      }
      return []
    }
  },

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        if (res) {
          if (this.phoneFieldErrors.length > 0) return
          if (this.addData.password.trim() === this.addData.confirm_password.trim()) {
            this.passwordAlert = false
            this.addStaff()
          } else {
            this.passwordAlert = true
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog-dialog--active-dialog--persistent {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/user/addStaff.vue